// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"1223":"assets/web/css/trade","2759":"assets/web/css/nmuk","5284":"assets/web/css/nv","7066":"assets/web/css/label-pdfs"}[chunkId] + ".css";
};